var _path, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLichidare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4836 7.09157L10.5278 29.5998",
    stroke: "#B70020",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.98047,
    y: 7.0918,
    width: 8.325,
    height: 9.25,
    rx: 4.1625,
    stroke: "url(#paint0_linear_23833_410651)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0898,
    y: 20.3496,
    width: 8.325,
    height: 9.25,
    rx: 4.1625,
    stroke: "url(#paint1_linear_23833_410651)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23833_410651",
    x1: 15.3564,
    y1: 9.16833,
    x2: 6.71929,
    y2: 9.85791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA0029"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23833_410651",
    x1: 30.4658,
    y1: 22.4261,
    x2: 21.8287,
    y2: 23.1157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA0029"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLichidare);
export default __webpack_public_path__ + "static/media/lichidare.1e2d641f.svg";
export { ForwardRef as ReactComponent };